import {
  Grid,
  TextField,
  Button,
  MenuItem,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import configServ from "../../services/config";
import IOSSwitch from "../../Components/Buttons/IOSSwitch";
import UpdateIcon from "@mui/icons-material/Update";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import { useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import ThreeImageUploader from "./ThreeImageUploader";
import toast from "react-hot-toast";

const BandhanRegistrationCard = ({
  isEdit,
  handlePopup,
  setIsEdit,
  editData,
  fetchImag,
  setEditData,
  fetchBandhan,
}) => {
  //#region
  const [validationErrors, setValidationErrors] = useState({});

  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);

  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [gotra, setGotra] = useState([]);
  const [kuldevi, setKuldevi] = useState([]);
  const fetchGotra = async () => {
    try {
      setLoading(true);
      const res = await configServ.getActiveGotra(company_id);
      if (res.status) {
        setGotra(res.data);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchKuldevi = async () => {
    try {
      setLoading(true);
      const res = await configServ.getActiveKuldevi(company_id);
      if (res.status) {
        setKuldevi(res.data);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGotra();
    fetchKuldevi();
  }, []);

  const initialFormData = {
    self_or_other: "self",
    name: "",
    date_of_birth: "",
    time_of_birth: "",
    place_of_birth: "",
    highest_education_one: "",
    profession: "",
    monthly_income: "",
    height: "",
    weight: "",
    complexion: "",
    blood_group: "",
    gotra_id: "",
    kuldevi_id: "",
    father_name: "",
    mother_name: "",
    correspondence_address: "",
    email: "",
    phone: "",
    image1: "",
    image2: "",
    image3: "",
    status: true,
    gender: "",
    father_occupation: "",
    mother_occupation: "",
    sibling1: "",
    profession1: "",
    sibling2: "",
    profession2: "",
    sibling3: "",
    profession3: "",
    dadaji: "",
    dadiji: "",
    nanaji: "",
    naniji: "",
    references1: "",
    references2: "",
    references3: "",
  };

  const validateForm = (data) => {
    const errors = {};

    // Required fields
    const requiredFields = [
      "self_or_other",
      "place_of_birth",
      "name",
      "date_of_birth",
      "time_of_birth",
      "gender",
      "highest_education_one",
      "profession",
      "monthly_income",
      "height",
      "weight",
      "blood_group",
      "gotra_id",
      "kuldevi_id",
      "father_name",
      "mother_name",
      "correspondence_address",
      "email",
      "phone",
      "image1",
      "image2",
      "image3",
      "complexion",
    ];

    requiredFields.forEach((field) => {
      if (!data[field] || data[field].toString().trim() === "") {
        errors[field] = "This field is required";
      }
    });

    // Email validation
    if (data.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = "Invalid email address";
    }

    // Phone validation (10 digits)
    if (data.phone && !/^[0-9]{10}$/.test(data.phone)) {
      errors.phone = "Phone must be 10 digits";
    }

    // Numeric validations
    if (data.monthly_income && isNaN(data.monthly_income)) {
      errors.monthly_income = "Monthly income must be a number";
    }

    if (data.height && isNaN(data.height)) {
      errors.height = "Height must be a number";
    }

    if (data.weight && isNaN(data.weight)) {
      errors.weight = "Weight must be a number";
    }

    return errors;
  };

  const [formData, setFormData] = useState(initialFormData);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // clear error for that field
    setValidationErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const [images, setImages] = useState({
    image1: "",
    image2: "",
    image3: "",
  });

  const handleSubmit = async () => {
    const errors = validateForm(formData);

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    setValidationErrors({});
    setFormLoading(true);

    const payload = {
      ...formData,
      company_id: company_id,
    };

    try {
      let res;

      if (isEdit) {
        // 🔄 UPDATE
        res = await configServ.editBandhan(formData.id, payload);
      } else {
        // ➕ CREATE
        res = await configServ.createBandhan(payload);
      }

      if (res?.status) {
        toast.success(
          isEdit
            ? "Bandhan updated successfully"
            : "Bandhan created successfully"
        );
        handleReset();
        setIsEdit(false);
        handlePopup();
        fetchBandhan();
      } else {
        toast.error(res?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Bandhan submit error:", error);
      toast.error("Server error, please try again");
    } finally {
      setFormLoading(false);
    }
  };
  const [uploaderKey, setUploaderKey] = useState(0);

  const handleReset = () => {
    setFormData(initialFormData);
    setImages({
      image1: "",
      image2: "",
      image3: "",
    });
    setValidationErrors({});
    // 🔥 force ThreeImageUploader remount
    setUploaderKey((prev) => prev + 1);
    setEditData(null);
    setIsEdit(false);
  };

  useEffect(() => {
    const loadImages = async () => {
      if (editData?.id) {
        console.log("Edit data received:", editData);

        const imageData = await fetchImag(editData.id); // {image1, image2, image3}
        console.log("Images from parent:", imageData);

        if (imageData) {
          // ✅ IMPORTANT: uploader ke liye
          setImages({
            image1: imageData.image1 || "",
            image2: imageData.image2 || "",
            image3: imageData.image3 || "",
          });

          // ✅ form ke liye
          setFormData((prev) => ({
            ...prev,
            ...editData,
            ...imageData,
          }));
        } else {
          setFormData({
            ...initialFormData,
            ...editData,
          });
        }
      }
    };

    loadImages();
  }, [editData]);

  //#endregion
  return (
    <>
      <motion.div
        style={{
          width: "100%",
          backgroundColor: "#e3f3fc",
          padding: 20,
          borderRadius: "10px",
        }}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.1, delay: 0.1 }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              label="Self / Other"
              name="self_or_other"
              value={formData.self_or_other}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.self_or_other}
              helperText={validationErrors.self_or_other}
            >
              <MenuItem value="self">Self</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              label={
                <span>
                  Name <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="name"
              InputLabelProps={{ shrink: true }}
              onChange={handleChange}
              value={formData.name || ""}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.name}
              helperText={validationErrors.name}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="date"
              fullWidth
              size="small"
              name="date_of_birth"
              label={
                <span>
                  DOB <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.date_of_birth}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.date_of_birth}
              helperText={validationErrors.date_of_birth}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              type="time"
              fullWidth
              size="small"
              name="time_of_birth"
              label={
                <span>
                  Time Of Birth <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.time_of_birth}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.time_of_birth}
              helperText={validationErrors.time_of_birth}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              //   type="time"
              fullWidth
              size="small"
              name="place_of_birth"
              label={
                <span>
                  Birth of place <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.place_of_birth}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.place_of_birth}
              helperText={validationErrors.place_of_birth}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              name="gender"
              label={
                <span>
                  Gender <span style={{ color: "red" }}>*</span>
                </span>
              }
              value={formData.gender}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.gender}
              helperText={validationErrors.gender}
            >
              <MenuItem value="">Select Gender</MenuItem>
              <MenuItem value="male">Male</MenuItem>
              <MenuItem value="female">Female</MenuItem>
              <MenuItem value="other">Other</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="highest_education_one"
              //   label="Highest Eduction 1"
              label={
                <span>
                  Highest Eduction 1 <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.highest_education_one}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.highest_education_one}
              helperText={validationErrors.highest_education_one}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="highest_education_two"
              label="Highest Eduction 2"
              InputLabelProps={{ shrink: true }}
              value={formData.highest_education_two}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="profession"
              label={
                <span>
                  Profession <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.profession}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.profession}
              helperText={validationErrors.profession}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="monthly_income"
              label={
                <span>
                  Monthly Income In Rs <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.monthly_income}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.monthly_income}
              helperText={validationErrors.monthly_income}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="height"
              label={
                <span>
                  Height In Feet <span style={{ color: "red" }}>*</span>
                </span>
              }
              InputLabelProps={{ shrink: true }}
              value={formData.height}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.height}
              helperText={validationErrors.height}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              fullWidth
              size="small"
              name="weight"
              label={
                <span>
                  Weight in Kg <span style={{ color: "red" }}>*</span>
                </span>
              }
              //   InputLabelProps={{ shrink: true }}
              value={formData.weight}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.weight}
              helperText={validationErrors.weight}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              name="complexion"
              label={
                <span>
                  Complexion <span style={{ color: "red" }}>*</span>
                </span>
              }
              value={formData.complexion}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.complexion}
              helperText={validationErrors.complexion}
            >
              <MenuItem value="">Select Complexion</MenuItem>
              <MenuItem value="very_fair">Very Fair</MenuItem>
              <MenuItem value="fair">Fair</MenuItem>
              <MenuItem value="wheatish_fair">Wheatish Fair</MenuItem>
              <MenuItem value="wheatish">Wheatish</MenuItem>
              <MenuItem value="medium">Medium</MenuItem>
              <MenuItem value="dusky">Dusky</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              name="blood_group"
              label={
                <span>
                  Blood Group <span style={{ color: "red" }}>*</span>
                </span>
              }
              value={formData.blood_group}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              error={!!validationErrors.blood_group}
              helperText={validationErrors.blood_group}
            >
              <MenuItem value="">Select Blood Group</MenuItem>
              <MenuItem value="A+">A+</MenuItem>
              <MenuItem value="A-">A-</MenuItem>
              <MenuItem value="B+">B+</MenuItem>
              <MenuItem value="B-">B-</MenuItem>
              <MenuItem value="AB+">AB+</MenuItem>
              <MenuItem value="AB-">AB-</MenuItem>
              <MenuItem value="O+">O+</MenuItem>
              <MenuItem value="O-">O-</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              label={
                <span>
                  Gotra <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="gotra_id"
              value={formData.gotra_id}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.gotra_id}
              helperText={validationErrors.gotra_id}
            >
              <MenuItem value="">Select</MenuItem>
              {gotra.map((g) => (
                <MenuItem key={g.id} value={g.id}>
                  {g.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              select
              fullWidth
              size="small"
              label={
                <span>
                  Kuldevi <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="kuldevi_id"
              value={formData.kuldevi_id}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              error={!!validationErrors.kuldevi_id}
              helperText={validationErrors.kuldevi_id}
            >
              <MenuItem value="">Select</MenuItem>
              {kuldevi.map((k) => (
                <MenuItem key={k.id} value={k.id}>
                  {k.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={
                <span>
                  Father Name <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="father_name"
              fullWidth
              size="small"
              value={formData.father_name}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              error={!!validationErrors.father_name}
              helperText={validationErrors.father_name}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Father Occupation"
              name="father_occupation"
              fullWidth
              size="small"
              value={formData.father_occupation}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={
                <span>
                  Mother Name <span style={{ color: "red" }}>*</span>{" "}
                </span>
              }
              name="mother_name"
              fullWidth
              size="small"
              value={formData.mother_name}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              error={!!validationErrors.mother_name}
              helperText={validationErrors.mother_name}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Mother Occupation"
              name="mother_occupation"
              fullWidth
              size="small"
              value={formData.mother_occupation}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={
                <span>
                  Corresspondence Address{" "}
                  <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="correspondence_address"
              fullWidth
              size="small"
              value={formData.correspondence_address}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              multiline
              rows={2}
              error={!!validationErrors.correspondence_address}
              helperText={validationErrors.correspondence_address}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Sibling 1 Name"
              name="sibling1"
              fullWidth
              size="small"
              value={formData.sibling1}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Sibling 1 Profession"
              name="profession1"
              fullWidth
              size="small"
              value={formData.profession1}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Sibling 2 Name"
              name="sibling2"
              fullWidth
              size="small"
              value={formData.sibling2}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Sibling 2 Profession"
              name="profession2"
              fullWidth
              size="small"
              value={formData.profession2}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Sibling 3 Name"
              name="sibling3"
              fullWidth
              size="small"
              value={formData.sibling3}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Sibling 3 Profession"
              name="profession3"
              fullWidth
              size="small"
              value={formData.profession3}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Dadaji"
              name="dadaji"
              fullWidth
              size="small"
              value={formData.dadaji}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Dadiji"
              name="dadiji"
              fullWidth
              size="small"
              value={formData.dadiji}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Nanaji"
              name="nanaji"
              fullWidth
              size="small"
              value={formData.nanaji}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Naniji"
              name="naniji"
              fullWidth
              size="small"
              value={formData.naniji}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Reference 1"
              name="references1"
              fullWidth
              size="small"
              value={formData.references1}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Reference 2"
              name="references2"
              fullWidth
              size="small"
              value={formData.references2}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label="Reference 3"
              name="references3"
              fullWidth
              size="small"
              value={formData.references3}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={
                <span>
                  Email <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="email"
              type="email"
              fullWidth
              size="small"
              value={formData.email}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              error={!!validationErrors.email}
              helperText={validationErrors.email}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <TextField
              label={
                <span>
                  Phone <span style={{ color: "red" }}>*</span>
                </span>
              }
              name="phone"
              fullWidth
              size="small"
              value={formData.phone}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
              InputLabelProps={{ shrink: true }}
              error={!!validationErrors.phone}
              helperText={validationErrors.phone}
            />
          </Grid>
          {/* <Grid container spacing={3} mt={2}>
            {[1, 2, 3].map((num) => {
              const key = `image${num}`;

              return (
                <Grid item xs={12} md={4} key={key}>
                  <div
                    style={{
                      background: "#fff",
                      padding: 10,
                      borderRadius: 8,
                      textAlign: "center",
                      border: "1px dashed #ccc",
                    }}
                  >
                    <img
                      src={formData[key] || demoImages[key]}
                      alt={`Preview ${num}`}
                      style={{
                        width: "100%",
                        height: 180,
                        objectFit: "cover",
                        borderRadius: 6,
                        marginBottom: 8,
                      }}
                    />

                    <Button
                      variant="outlined"
                      component="label"
                      fullWidth
                      size="small"
                    >
                      Upload Image {num}
                      <input
                        hidden
                        type="file"
                        accept="image/*"
                        onChange={(e) => handleImageChange(e, key)}
                      />
                    </Button>
                  </div>
                </Grid>
              );
            })}
          </Grid> */}
          <ThreeImageUploader
            key={uploaderKey}
            value={images}
            onChange={(data) => {
              setImages(data);

              setFormData((prev) => ({
                ...prev,
                ...data,
              }));

              // ✅ clear validation error for updated image(s)
              setValidationErrors((prev) => {
                const updatedErrors = { ...prev };
                Object.keys(data).forEach((key) => {
                  delete updatedErrors[key];
                });
                return updatedErrors;
              });
            }}
            validationErrors={validationErrors}
          />
          {/* Active Status */}
          <Grid item xs={12} md={3}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <IOSSwitch
                    checked={formData.status}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        status: e.target.checked,
                      }))
                    }
                    name="status"
                  />
                }
                label="Active"
              />
            </FormGroup>
          </Grid>
        </Grid>

        {/* Buttons */}
        <Grid container spacing={2} justifyContent="flex-end" mt={2}>
          <Grid item>
            <Button
              onClick={handleReset}
              variant="contained"
              color="secondary"
              startIcon={<RotateLeftIcon />}
            >
              Reset
            </Button>
          </Grid>
          <Grid item>
            <Button
              onClick={handleSubmit}
              variant="contained"
              color={isEdit ? "success" : "primary"}
              startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
              disabled={formLoading}
            >
              {isEdit ? "Update" : "Save"}
            </Button>
          </Grid>
        </Grid>
      </motion.div>
    </>
  );
};

export default BandhanRegistrationCard;
